import { ProgressSpinner } from 'primereact/progressspinner';
import { useTranslation } from 'react-i18next';

import { i18nNameSpace } from '@shared/consts/i18n';
import { useUserLanguage } from '@shared/hooks/useLanguage.ts';

import styles from './AuthenticatingScreen.module.scss';

function AuthenticatingScreen() {
  const { t } = useTranslation(i18nNameSpace.COMMON);
  const { userLanguage } = useUserLanguage();

  const spinnerText = userLanguage ? t('authenticationInProgress') : 'Authentication in progress...';

  return (
    <div className={styles.wrapper}>
      <ProgressSpinner />
      <p className={styles.paragraph}>{spinnerText}</p>
    </div>
  );
}

export default AuthenticatingScreen;
